import { render, staticRenderFns } from "./NewBot.vue?vue&type=template&id=19c8b3aa"
import script from "./NewBot.vue?vue&type=script&lang=js"
export * from "./NewBot.vue?vue&type=script&lang=js"
import style0 from "./NewBot.vue?vue&type=style&index=0&id=19c8b3aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports